import * as Yup from 'yup';

// We use the default format validation for production
// 11 alphanumeric characters or 10 numeric characters
const COUPON_REGEX = process.env.REACT_APP_ACTIVATION_CODE_REGEX || /^([A-Za-z0-9]{11}|\d{10})$/;

export const guestTestKitValidationSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Email is required'),
  birthDate: Yup.string().required('Born date is required'),
  activationCode: Yup.string()
    .required('Activation code is required')
    .matches(new RegExp(COUPON_REGEX), 'Invalid activation code'),
});

export const authenticatedTestKitValidationSchema = Yup.object().shape({
  activationCode: Yup.string()
    .required('Activation code is required')
    .matches(new RegExp(COUPON_REGEX), 'Invalid activation code'),
});
